var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0013 13.8333C1.0013 14.75 1.7513 15.5 2.66797 15.5H9.33464C10.2513 15.5 11.0013 14.75 11.0013 13.8333V3.83333H1.0013V13.8333ZM2.66797 5.5H9.33464V13.8333H2.66797V5.5ZM8.91797 1.33333L8.08464 0.5H3.91797L3.08464 1.33333H0.167969V3H11.8346V1.33333H8.91797Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-trash.1889bb71e6754d4c02da92be06e17c6f.svg";